import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  ledger: null,
  gstreport: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
};

const dailyGSTReportSlice = createSlice({
  name: "dailyGSTReport",
  initialState,
  reducers: {
    fetchDailyGSTReportSheetStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDailyGSTReportSheetSuccess(state, action) {
      state.gstreport = action.payload.gstreport;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchDailyGSTReportSheetFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    fetchLedgerReportSheetStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchLedgerReportSheetSuccess(state, action) {
      state.ledger = action.payload.ledger;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchLedgerReportSheetFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addExcelStart(state) {
      state.loading = true;
      state.error = null;
    },
    addExcelSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    addExcelFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // deleteSupplierStart(state) {
    //   state.loading = true;
    //   state.error = null;
    // },
    // deleteSupplierSuccess(state, action) {
    //   state.loading = false;
    //   state.suppliers = state.suppliers.filter(
    //     (supplier) => supplier.id !== action.payload
    //   );
    //   state.error = null;
    // },
    // deleteSupplierFailure(state, action) {
    //   state.loading = true;
    //   state.error = action.payload;
    // },
    // editSupplierStart(state) {
    //   state.loading = true;
    //   state.error = null;
    // },
    // editSupplierSuccess(state, action) {
    //   state.loading = false;
    //   const updatedSupplier = action.payload;
    //   const index = state.suppliers.findIndex(
    //     (supplier) => supplier.id === updatedSupplier.id
    //   );
    //   if (index !== -1) {
    //     state.suppliers[index] = updatedSupplier;
    //   }
    //   state.error = null;
    // },
    // editSupplierFailure(state, action) {
    //   state.loading = true;
    //   state.error = action.payload;
    // },

    // getCategoryByIdStart(state) {
    //   state.loading = false;
    //   state.error = null;
    //   state.selectedCategory = null;
    // },
    // getCategoryByIdSuccess(state, action) {
    //   state.loading = false;
    //   state.selectedCategory = action.payload;
    //   state.error = null;
    // },
    // getCategoryByIdFailure(state, action) {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    resetDailyGSTReports(state) {
      state.gstreport = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchDailyGSTReportSheetStart,
  fetchDailyGSTReportSheetSuccess,
  fetchDailyGSTReportSheetFailure,
  fetchLedgerReportSheetStart,
  fetchLedgerReportSheetSuccess,
  fetchLedgerReportSheetFailure,
  addExcelStart,
  addExcelSuccess,
  addExcelFailure,
  //   addSupplierStart,
  //   addSupplierSuccess,
  //   addSupplierFailure,
  //   deleteSupplierStart,
  //   deleteSupplierSuccess,
  //   deleteSupplierFailure,
  //   editSupplierStart,
  //   editSupplierSuccess,
  //   editSupplierFailure,
  //   getCategoryByIdFailure,
  //   getCategoryByIdStart,
  //   getCategoryByIdSuccess,
  resetDailyGSTReports,
} = dailyGSTReportSlice.actions;

export default dailyGSTReportSlice.reducer;
